<div class="label-updater-wrapper round-content ch-grey">
  <div class="label-updater-title">
    <p class="label-updater-header-text">{{'MSISDN.LABEL' | translate}}</p>
  </div>

  <div class="label-updater-body" [class.invalid]="disableButton()">
    <form [formGroup]="form" class="label-updater-form" (ngSubmit)="onSubmit()">
      <label for="label" class="labels-number">
        <cc-flag-number-item [label]="msisdn.label"
                             [number]="msisdn.msisdn"
                             [empty]="'UNKNOWN'">
        </cc-flag-number-item>
      </label>
      <mat-form-field class="label-updater-input">
        <input matInput id="label" formControlName="label"
               [errorStateMatcher]="matcher"
               type="text"/>
        <mat-error class="text-danger"
             *ngIf="form.hasError('unique', ['label'])">
          {{'LABEL_EXISTS' | translate}}
        </mat-error>
        <mat-error class="text-danger"
             *ngIf="form.hasError('required', ['label'])">
          {{'REQUIRED_FIELD_MESSAGE' | translate}}
        </mat-error>
        <mat-error class="text-danger"
             *ngIf="form.hasError('fourByteCharacter', ['label'])">
          {{'INVALID_CHARACTERS' | translate}}
        </mat-error>
      </mat-form-field>


      <button mat-raised-button
              color="info-full"
              type="submit"
              [disabled]="disableButton()">
        {{'SAVE' | translate}}
      </button>
    </form>
  </div>
</div>
